module.exports = __webpack_public_path__ + "img/planwave-1.b11dc256.png";